import React from 'react';

const CompassHUD = ({ degree }) => {
  const compassPoints = [
    // Original and repeated compass points
    { label: 'N', degree: 0 }, { label: '15', degree: 15 }, { label: '30', degree: 30 },
    { label: 'NE', degree: 45 }, { label: '60', degree: 60 }, { label: '75', degree: 75 },
    { label: 'E', degree: 90 }, { label: '105', degree: 105 }, { label: '120', degree: 120 },
    { label: 'SE', degree: 135 }, { label: '150', degree: 150 }, { label: '165', degree: 165 },
    { label: 'S', degree: 180 }, { label: '195', degree: 195 }, { label: '210', degree: 210 },
    { label: 'SW', degree: 225 }, { label: '240', degree: 240 }, { label: '255', degree: 255 },
    { label: 'W', degree: 270 }, { label: '285', degree: 285 }, { label: '300', degree: 300 },
    { label: 'NW', degree: 315 }, { label: '330', degree: 330 }, { label: '345', degree: 345 },
    { label: 'N', degree: 360 }, { label: '15', degree: 375 }, { label: '30', degree: 390 },
    { label: 'NE', degree: 405 }, { label: '60', degree: 420 }, { label: '75', degree: 435 },
    { label: 'E', degree: 450 }, { label: '105', degree: 465 }, { label: '120', degree: 480 },
    { label: 'SE', degree: 495 }, { label: '150', degree: 510 }, { label: '165', degree: 525 },
    { label: 'S', degree: 540 }, { label: '195', degree: 555 }, { label: '210', degree: 570 },
    { label: 'SW', degree: 585 }, { label: '240', degree: 600 }, { label: '255', degree: 615 },
    { label: 'W', degree: 630 }, { label: '285', degree: 645 }, { label: '300', degree: 660 },
    { label: 'NW', degree: 675 }, { label: '330', degree: 690 }, { label: '345', degree: 705 },
    { label: 'N', degree: 720 }, { label: '15', degree: 735 }, { label: '30', degree: 750 },
    { label: 'NE', degree: 765 }, { label: '60', degree: 780 }, { label: '75', degree: 795 },
    { label: 'E', degree: 810 }, { label: '105', degree: 825 }, { label: '120', degree: 840 },
    { label: 'SE', degree: 855 }, { label: '150', degree: 870 }, { label: '165', degree: 885 },
    { label: 'S', degree: 900 }, { label: '195', degree: 915 }, { label: '210', degree: 930 },
    { label: 'SW', degree: 945 }, { label: '240', degree: 960 }, { label: '255', degree: 975 },
    { label: 'W', degree: 990 }, { label: '285', degree: 1005 }, { label: '300', degree: 1020 },
    { label: 'NW', degree: 1035 }, { label: '330', degree: 1050 }, { label: '345', degree: 1065 },
    { label: 'N', degree: 1080 },
  ];

  const calculateOffset = (inputDegree) => {
    const normalizedDegree = (inputDegree + 360) % 1080;
    return ((normalizedDegree - 540) / 360) * 96.5;
  };

  return (
    <div
      className="compass"
      style={{
        position: 'relative',
        width: '100%',
        height: '5rem',
        overflow: 'hidden',
        padding: '0 2rem',
        maskImage: 'linear-gradient(90deg, transparent, #000 50%, transparent)',
        WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 50%, transparent)',
      }}
    >
      <div
        className="points"
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          width: '300%',
          height: '100%',
          display: 'flex',
          transform: `translateX(calc(-150% - ${calculateOffset(degree - 14.5)}%))`,
          transition: 'transform 0.3s ease-out',
        }}
      >
        {compassPoints.map((point) => (
          <div
            key={point.degree}
            className="point"
            style={{
              flex: '0 0 4%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1rem',
              fontWeight: 'bold',
              color: 'black',
              textShadow: `
                -1px -1px 0 white,
                1px -1px 0 white,
                -1px  1px 0 white,
                1px  1px 0 white
              `,
            }}
          >
            {point.label}
            
          </div>
        ))}
      </div>

      <div
        className="absolute top-0 left-0 w-full h-full flex items-end justify-center -mt-2"
        style={{ zIndex: 1 }}
      >
        <div
            className="point"
            style={{
              flex: '0 0 4%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              textShadow: `
                -1px -1px 0 white,
                1px -1px 0 white,
                -1px  1px 0 white,
                1px  1px 0 white
              `,
            }}
          >
            <svg stroke="#ffffff" fill="#000000" strokeWidth="1" version="1.2" baseProfile="tiny" viewBox="0 0 24 24" height="30px" width="30px" xmlns="http://www.w3.org/2000/svg"><path d="M18.2 13.3l-6.2-6.3-6.2 6.3c-.2.2-.3.5-.3.7s.1.5.3.7c.2.2.4.3.7.3h11c.3 0 .5-.1.7-.3.2-.2.3-.5.3-.7s-.1-.5-.3-.7z"></path></svg>
            
          </div>
      </div>
    </div>
  );
};

export default CompassHUD;

